import {
  LOGO_SIZE,
  LOGO_TEXT_SIZE,
} from '../../layouts/OnboardingWizard/consts';
import { QodoAnteater, QodoText } from '../../logos';

export const LogoOnlyHeader = () => (
  <header className="h-16 flex items-center px-12 py-16 absolute top-0 inset-x-0">
    <div className="flex items-center gap-2">
      {/* TODO:: Move logo+text to a standalone component. Ticket -> https://linear.app/qodo/issue/ENT-1209/move-logo-text-to-a-standalone-component */}
      <QodoAnteater size={LOGO_SIZE} />
      <QodoText size={LOGO_TEXT_SIZE} />
    </div>
  </header>
);
